import type { GridFilterModel, GridPaginationModel, GridSortModel } from '@mui/x-data-grid-pro';
import { useSearchParams } from 'react-router-dom';

import { buildQueryString } from '../../utils/buildQueryString';

export const useDataGridSearchParams = (
  mode: 'client' | 'server',
  disableSearchParamSync: boolean,
  additionalQueryArgs?: string,
  paginationModel?: GridPaginationModel,
  sortModel?: GridSortModel,
  filterModel?: GridFilterModel,
  serializeDateFilterValues?: boolean
) => {
  const [searchParams] = useSearchParams();
  const currentSearchParams = disableSearchParamSync
    ? buildQueryString({
        paginationModel,
        sortModel,
        filterModel,
        serializeDateFilterValues,
      })
    : searchParams.toString();
  /** Assemble all url params */
  const additionalQueryArgsString = additionalQueryArgs
    ? currentSearchParams
      ? `&${additionalQueryArgs}`
      : `${additionalQueryArgs}`
    : '';

  if (mode === 'server') {
    return currentSearchParams || additionalQueryArgsString
      ? `?${currentSearchParams}${additionalQueryArgsString}`
      : '';
  }

  // return for client state
  return additionalQueryArgsString ? `?${additionalQueryArgsString}` : '';
};
